export function defaultTrueHtml() {
  return `<i class="fas fa-check default-true-html"></i>`;
}
